import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import Grid from '@mui/material/GridLegacy'

import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'
import { QuizApi } from '@trivie/core/src/services/api-objects'

import { QuizList } from './components/quiz-list'
import ContentCreationHeader from './content-creation-header'
import ContentCreationHeaderTitle from './content-creation-header-title'

export const ImportQuizScreen: React.FunctionComponent = observer(() => {
  const history = useHistory()
  const { contentCreationStore } = useStores()
  const { importingQuizzes, importingFilename } = contentCreationStore

  const handlePublish = async () => {
    history.push('/content/quizzes')
  }

  const [existingQuizNames, setExistingQuizNames] = useState([])
  useEffect(() => {
    QuizApi.getAllQuizzes('quizzes', false, [{ field: 'quiz_title' }], 'list_quizzes').then(
      (res: any) =>
        setExistingQuizNames(
          res.data.rows.map((row) =>
            row.columns
              .find((c) => c.field === 'quiz_title')
              ?.value?.replace(/\s+/g, '')
              ?.toLowerCase(),
          ),
        ),
    )
  }, [])

  useEffect(() => {
    importingQuizzes?.map((q) => {
      if (
        existingQuizNames &&
        existingQuizNames.includes(q?.title?.replace(/\s+/g, '')?.toLowerCase() as never) &&
        q?.title?.replace(/\s+/g, '')?.toLowerCase() !==
          q?.original_name?.replace(/\s+/g, '')?.toLowerCase()
      ) {
        q?.set('duplicate_name', true)
      } else {
        q?.set('duplicate_name', false)
      }
    })
  }, [existingQuizNames?.length])

  return (
    <div style={ROOT}>
      <ContentCreationHeader
        onBack={handlePublish}
        showUnsavedPopup
        publishData={importingQuizzes}
        titleHeader={
          <ContentCreationHeaderTitle
            titles={[{ title: `Importing - ${importingFilename}`, isPlaceholder: true }]}
          />
        }
      />
      <div style={CONTENT}>
        <div id="QuizListContainer" style={CONTAINER}>
          <Grid container spacing={2} style={{ maxWidth: 1400, justifyContent: 'center' }}>
            <QuizList
              importing
              style={{ flex: 1, maxWidth: 1000 }}
              quizzes={importingQuizzes}
              existingQuizNames={existingQuizNames}
            />
          </Grid>
        </div>
      </div>
    </div>
  )
})

const CONTAINER: React.CSSProperties = {
  padding: 40,
  height: 'calc(100% - 70px)',
  display: 'flex',
  justifyContent: 'center',
  overflowY: 'auto',
  width: '100%',
}
const ROOT: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  background: 'rgb(244, 244, 244)',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
}
const CONTENT: React.CSSProperties = { display: 'flex', flexDirection: 'row', height: '100%' }
